import { concat, uniq } from "ramda";
const replaceIfNaN = (value, defaultValue) => Number.isNaN(value) ? defaultValue : value;
export class QualityFulfillmentMetricsCollector {
    elementInfos = new Map();
    mediaSources = new Map();
    constructor() { }
    start() {
        this.stop();
    }
    stop() {
        this.elementInfos.clear();
        this.mediaSources.clear();
    }
    trackElementInfo(id, elementInfo) {
        this.elementInfos.set(id, elementInfo);
    }
    stopTrackingElementInfo(id) {
        this.elementInfos.delete(id);
    }
    handleInfo = (info) => {
        const filterUndefined = (entry) => entry[1] !== undefined;
        const mediaSourcesOrUndefined = Object.entries(info).map(([id, idInfo]) => [id, idInfo.video]);
        const mediaSources = mediaSourcesOrUndefined.filter(filterUndefined);
        this.mediaSources = new Map(mediaSources);
    };
    sample() {
        const allIds = uniq(concat(Array.from(this.elementInfos.keys()), Array.from(this.mediaSources.keys())));
        const qualityFulfillmentStatsPerUser = allIds.map((id) => {
            const elementInfo = this.elementInfos.get(id);
            const mediaSource = this.mediaSources.get(id);
            const desiredDimensions = {
                width: elementInfo?.width() || 0,
                height: elementInfo?.height() || 0,
            };
            const actualDimensions = {
                width: mediaSource?.videoTrack?.getSettings().width || 0,
                height: mediaSource?.videoTrack?.getSettings().height || 0,
            };
            const actualPixels = actualDimensions.width * actualDimensions.height;
            let desiredPixels = desiredDimensions.width * desiredDimensions.height;
            if (actualDimensions.height === 0 && actualDimensions.width === 0) {
                desiredPixels = 0;
            }
            return { desiredPixels, actualPixels };
        });
        const totalDesiredPixels = qualityFulfillmentStatsPerUser
            .map((stat) => stat.desiredPixels)
            .reduce((x, y) => x + y, 0);
        const totalActualPixels = qualityFulfillmentStatsPerUser
            .map((stat) => stat.actualPixels)
            .reduce((x, y) => x + y, 0);
        const totalActualPixelsCapped = qualityFulfillmentStatsPerUser
            .map((stat) => Math.min(stat.actualPixels, stat.desiredPixels))
            .reduce((x, y) => x + y, 0);
        const totalActualPixelsFloored = qualityFulfillmentStatsPerUser
            .map((stat) => Math.max(stat.actualPixels, stat.desiredPixels))
            .reduce((x, y) => x + y, 0);
        return {
            qualityFulfillmentRatio: replaceIfNaN(totalActualPixels / totalDesiredPixels, 1),
            qualityFulfillmentRatioUnder: replaceIfNaN(totalActualPixelsCapped / totalDesiredPixels, 1),
            qualityFulfillmentRatioOver: replaceIfNaN(totalActualPixelsFloored / totalDesiredPixels, 1),
            qualityFulfillmentError: totalActualPixels - totalDesiredPixels,
            qualityFulfillmentErrorUnder: totalDesiredPixels - totalActualPixelsCapped,
            qualityFulfillmentErrorOver: totalActualPixelsFloored - totalDesiredPixels,
        };
    }
    outputMetrics() {
        if (this.elementInfos.size === 0 && this.mediaSources.size === 0)
            return [];
        return [
            {
                name: "quality-fulfillment-ratio",
                values: this.sample(),
            },
        ];
    }
    resetCollection() {
    }
}
//# sourceMappingURL=QualityFulfillmentMetricsCollector.js.map